import { GLOBAL_EVENTS } from '../cfg/constants/global-events';
export class UIManager {
    constructor(scene) {
        this.scene = scene;
        this.currentState = 0 /* EGameState.MATCH_SCREEN */;
        this.isGameStarted = false;
        this.scene = scene;
        // this.matchScreen.hide();
        // this.scoreBreakup.show({ perfect: 2, good: 4, correct: 6, bingo: 9, score: 1050, wrong: 3 });
        this.addEventHandlers();
        this.addGlobalEventHandlers();
    }
    addEventHandlers() {
    }
    addGlobalEventHandlers() {
        // this.scene.globalEvents
        // 	.on(GLOBAL_EVENTS.SHOW_FEEDBACK, (feedbackType: EFeedback, points: number) => {
        // 		this.feedback.showFeedback(feedbackType);
        // 		// this.scoreUI.addPoints(points);
        // 	})
        // 	.on(GLOBAL_EVENTS.END_GAME, () => {
        // 		// this.overlay.transitionShow();
        // 		this.handleResults();
        // 	});
    }
    handleNextStateCommon(nextState) {
        switch (nextState) {
            case 1 /* EGameState.GAME */:
                break;
            // Show popup overlay for all states except the above
            default:
            // this.popupOverlay.show();
        }
    }
    handlePreviousStateCommon(currentState) {
        switch (currentState) {
            case 1 /* EGameState.GAME */:
                break;
            // hide popup overlay for all states except the above
            default:
            // this.popupOverlay.hide();
        }
    }
    changeState(nextState) {
        // Previous Stata
        switch (this.currentState) {
            case 0 /* EGameState.MATCH_SCREEN */:
                // this.matchScreen.hide();
                break;
            case 1 /* EGameState.GAME */:
                break;
            case 2 /* EGameState.END */:
                break;
        }
        this.handlePreviousStateCommon(this.currentState);
        this.handleNextStateCommon(nextState);
        switch (nextState) {
            case 1 /* EGameState.GAME */:
                this.scene.globalEvents.emit(GLOBAL_EVENTS.SETUP_GAME);
                break;
            case 2 /* EGameState.END */:
                console.warn('end transition');
                break;
        }
        this.currentState = nextState;
        this.resizeAndRepositionElements();
    }
    resizeAndRepositionElements() {
        let { width: w, height: h } = this.scene.resizeDim;
        w /= this.scene.grs.dpr;
        h /= this.scene.grs.dpr;
        // this.overlay.resizeAndRepositionElements(w, h);
        // this.playerUI.resizeAndRepositionElements(w, h);
        // this.opponentUI.resizeAndRepositionElements(w, h);
        // switch (this.currentState) {
        // 	case EGameState.MATCH_SCREEN:
        // 		this.matchScreen.resizeAndRepositionElements(w, h);
        // 		break;
        // 	case EGameState.GAME:
        // 		this.feedback.resizeAndRepositionElements(w, h);
        // 		this.scoreUI.resizeAndRepositionElements(w, h);
        // 		this.timerUI.resizeAndRepositionElements(w, h);
        // 		break;
        // 	case EGameState.END:
        // 		this.endScreen.resizeAndRepositionElements(w, h);
        // 		this.scoreBreakup.resizeAndRepositionElements(w, h);
        // 		break;
        // }
    }
}
